module.exports = __webpack_public_path__ + "static/media/icon_pencil.f1bf6d8c.svg";